import { useCallback, useEffect, useState } from "react";
import { Gauge, Coins } from "lucide-react";
import api from "@/lib/api";

export const CreditMeter = ({ refreshKey = 0, live = false, scanSecs = 15 }) => {
  const [u, setU] = useState(null);
  const load = useCallback(() => api.get("/copilot/usage").then(({ data }) => setU(data)).catch(() => {}), []);
  useEffect(() => { load(); }, [load, refreshKey]);
  useEffect(() => { if (!live) return; const id = setInterval(load, 60000); return () => clearInterval(id); }, [live, load]);
  if (!u) return null;
  const pct = Math.min(100, Math.round((u.today.scans / u.daily_soft_limit) * 100));
  const bar = u.limit_reached ? "bg-red-500" : pct >= 70 ? "bg-amber-400" : "bg-emerald-500";
  return (
    <div className="glass rounded-2xl p-4" data-testid="credit-meter">
      <div className="flex items-center justify-between mb-2">
        <p className="text-sm font-semibold flex items-center gap-2"><Gauge className="w-4 h-4 text-cyan-400" /> AI usage today</p>
        <span className="font-mono-num text-sm font-bold" data-testid="credit-meter-cost">~${u.today.est_cost_usd.toFixed(2)}</span>
      </div>
      <div className="h-1.5 rounded-full bg-white/5 overflow-hidden mb-2">
        <div className={`h-full rounded-full transition-[width] duration-500 ${bar}`} style={{ width: `${pct}%` }} data-testid="credit-meter-bar" />
      </div>
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-slate-400 font-mono-num">
        <span data-testid="credit-meter-scans"><span className="text-white font-semibold">{u.today.scans}</span>/{u.daily_soft_limit} scans</span>
        <span>{u.today.live_scans} live · {u.today.upload_scans} upload</span>
        <span>{u.today.chats} broker chats</span>
        <span className="ml-auto">month ~${u.month.est_cost_usd.toFixed(2)}</span>
      </div>
      {live && (
        <p className="text-[11px] text-cyan-300 mt-2 flex items-center gap-1" data-testid="credit-meter-live-rate">
          <Coins className="w-3 h-3" /> Live mode at {scanSecs}s ≈ ${u.live_hourly_est[String(scanSecs)]}/hour ({Math.round(3600 / scanSecs)} scans)
        </p>
      )}
      {u.limit_reached && <p className="text-[11px] text-red-400 mt-2" data-testid="credit-meter-limit">Daily soft limit reached — live scanning paused. Uploads still work.</p>}
      <p className="text-[10px] text-slate-500 mt-1.5">Estimates at ${u.rates.scan_usd}/scan · ${u.rates.chat_usd}/chat. Admin can adjust rates.</p>
    </div>
  );
};
